import React from 'react';
import { ScrollReveal } from './ScrollReveal';
export function Intro() {
  return <section className="py-20 md:py-32 px-5 md:px-10 border-b border-rule/60" data-id="element-128">
      <div className="max-w-4xl mx-auto" data-id="element-129">
        <ScrollReveal data-id="element-130">
          <p className="text-[10px] uppercase tracking-[0.3em] text-gold mb-6 font-medium" data-id="element-131">
            — Intro
          </p>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl leading-[1.1] tracking-tight text-ink font-light mb-10 md:mb-14" data-id="element-132">
            This proposal is designed to help you move from{' '}
            <em className="italic text-gold" data-id="element-133">idea</em> to{' '}
            <em className="italic text-gold" data-id="element-134">clarity</em>.
          </h2>
          <p className="font-serif text-lg md:text-xl text-ink-soft leading-relaxed font-light max-w-2xl" data-id="element-135">
            From our session, it is clear there is genuine potential in the
            product, the story, and the emotional meaning behind it. The next
            step is to shape those elements into a brand that feels clear,
            credible, premium, and ready to launch properly.
          </p>
        </ScrollReveal>
      </div>
    </section>;
}